import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

const switchApi = tiktokApi.tikTokFollowReply.switch

export const toggleTikTokFlow = createAsyncAction(
  `${NAMESPACE}/toggleFlow`,
  async (enabled: boolean) => {
    const toggledFlowData = await tiktokApi.tikTokFollowReply.switch({ body: { enabled } })

    return toggledFlowData.data
  },
  {
    autoHandleByGuards: [
      switchApi.isFlowIsNotSetError,
      switchApi.isFlowIsNotPublishedError,
      switchApi.isPrivateReplyIsRequiredError,
    ],
  },
)

export const toggleTikTokFlowReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder
    .addCase(toggleTikTokFlow.pending, (state) => ({ ...state, isToggling: true }))
    .addCase(toggleTikTokFlow.rejected, (state) => ({ ...state, isToggling: false }))
    .addCase(toggleTikTokFlow.fulfilled, (state, action) => ({
      ...state,
      ...getTikTokFollowWelcomeState(action.payload),
      isToggling: false,
    }))
}
